<template>

    <div>
        <rkm-row v-if="!isAmbulatorio">
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :requestQueryStringParams="autocompleteRequestParams.usuario"
                    :searchFields="fields.autocomplete.usuario"
                    :validations="validations.usuario"
                    text-field="cidadaoNome"
                    label="Profissional"
                    placeholder="Digite o nome ou número do conselho profissional"
                    v-model="data.model.cadastro.usuario"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="unidades"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="data.model.cadastro.unidadeId"
                    :validations="validations.unidade"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="isDisabled"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="infraestruturas"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.cadastro.infraestruturaId"
                    :validations="validations.infraestrutura"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="data.model.cadastro.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Código da equipe"
                    :options="equipes"
                    textField="descricao"
                    v-model="data.model.cadastro.equipeId"
                    :validations="validations.equipe"
                    valueField="id"
                    show-default-option
                    :disabled="data.model.cadastro.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    label="Ocupação"
                    :options="ocupacoes"
                    textField="codigoNome"
                    v-model="data.model.cadastro.ocupacaoId"
                    :validations="validations.ocupacao"
                    valueField="id"
                    show-default-option
                    :disabled="data.model.cadastro.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-col>
                    <rkm-form-date-picker
                        label="Data"
                        :max-date="data.form.dataAtual"
                        v-model="data.model.cadastro.dataUsuarioResponsavel"
                        :validations="validations.data"
                        right
                    />
                </rkm-col>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="isAmbulatorio && agendamento">
            <rkm-col cols="6">
                <rkm-form-input
                    label="Profissional"
                    v-model="agendamento.model.usuarioNome"
                    uppercase
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Unidade"
                    v-model="agendamento.model.unidade"
                    uppercase
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Local de atendimento"
                    v-model="agendamento.model.infraestrutura"
                    uppercase
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Código da equipe"
                    :options="equipes"
                    textField="descricao"
                    v-model="data.model.cadastro.equipeId"
                    :validations="validations.equipe"
                    valueField="id"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Ocupação"
                    v-model="agendamento.model.ocupacao"
                    uppercase
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-col>
                    <rkm-form-date-picker
                        label="Data"
                        :max-date="data.form.dataAtual"
                        v-model="agendamento.model.data"
                        disabled
                    />
                </rkm-col>
            </rkm-col>
        </rkm-row>

        <rkm-area
            title="Profissional auxiliar"
            no-margin-top
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.usuario"
                        :requestQueryStringParams="autocompleteRequestParams.usuarioAuxiliar"
                        :searchFields="fields.autocomplete.usuario"
                        text-field="cidadaoNome"
                        label="Profissional"
                        placeholder="Digite o nome ou número do conselho profissional"
                        v-model="data.model.cadastro.usuarioAuxiliar"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="unidadesAuxiliar"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="data.model.cadastro.unidadeAuxiliarId"
                        :validations="validations.unidadeAuxiliar"
                        default-option-text="Selecione"
                        value-field="id"
                        :disabled="isAuxiliarDisabled"
                    />
                </rkm-col>

                <rkm-col cols="6">
                <rkm-form-select
                    :options="infraestruturasAuxuliar"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.cadastro.infraestruturaAuxiliarId"
                    :validations="validations.infraestruturaAuxiliar"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="data.model.cadastro.unidadeAuxiliarId == null"
                />
            </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Código da equipe"
                        :options="equipesAuxiliar"
                        textField="descricao"
                        v-model="data.model.cadastro.equipeAuxiliarId"
                        :validations="validations.equipeAuxiliar"
                        valueField="id"
                        show-default-option
                        :disabled="data.model.cadastro.infraestruturaAuxiliarId == null"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Ocupação"
                        :options="ocupacoesAuxiliar"
                        textField="codigoNome"
                        v-model="data.model.cadastro.ocupacaoAuxiliarId"
                        :validations="validations.ocupacaoAuxiliarId"
                        valueField="id"
                        show-default-option
                        :disabled="data.model.cadastro.infraestruturaAuxiliarId == null"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

    </div>

</template>

<script>
// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

// Enums.
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'

export default {
    computed: {
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.ATENDIMENTO_INDIVIDUAL,
                    not_usuario_id: this.data.model.cadastro.usuarioAuxiliar && this.data.model.cadastro.usuarioAuxiliar.id
                        ? this.data.model.cadastro.usuarioAuxiliar.id
                        : null,
                },
                usuarioAuxiliar: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    not_usuario_id: this.data.model.cadastro.usuario && this.data.model.cadastro.usuario.id
                        ? this.data.model.cadastro.usuario.id
                        : null,
                },
            }
        },
        validations() {
            return {
                usuario: { required: true },
                unidade: { required: true },
                equipe: { required: true },
                ocupacao: { required: true },
                data: { required: true },
                unidadeAuxiliar: { required: true },
                infraestrutura: { required: true },
                equipeAuxiliar: { required: true },
                ocupacaoAuxiliar: { required: true },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        isDisabled() {

            return !this.data.model.cadastro.usuario
                || this.data.model.cadastro.usuario && !this.data.model.cadastro.usuario.id
        },
        isAuxiliarDisabled() {

            return !this.data.model.cadastro.usuarioAuxiliar
                || this.data.model.cadastro.usuarioAuxiliar && !this.data.model.cadastro.usuarioAuxiliar.id
        }
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            atendimentoIndividual: this.getConectaSusRepository('atencaoBasica.atendimentoIndividual')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getUnidades() {

            if (this.data.model.cadastro.usuario.id) {

                this.setLoading()

                this.repositories.atendimentoIndividual.getUnidades({usuario_id: this.data.model.cadastro.usuario.id})
                    .then(({ data }) => {

                        this.unidades = data

                        if (data.length === 1){

                            this.data.model.cadastro.unidadeId = data[0].id
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getInfraestruturas() {

            this.setLoading()

            this.repositories.atendimentoIndividual.getInfraestruturas({
                usuario_id: this.data.model.cadastro.usuario.id,
                unidade_id: this.data.model.cadastro.unidadeId
            })
                .then(({ data }) => {

                    this.infraestruturas = data

                    if (data.length === 1) {

                        this.data.model.cadastro.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUnidadesAuxiliar() {

            if (this.data.model.cadastro.usuarioAuxiliar.id) {

                this.setLoading()

                this.repositories.atendimentoIndividual.getUnidades({usuario_id: this.data.model.cadastro.usuarioAuxiliar.id})
                    .then(({ data }) => {

                        this.unidadesAuxiliar = data

                        if (data.length === 1){

                            this.data.model.cadastro.unidadeAuxiliarId = data[0].id
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getInfraestruturasAuxiliar() {

            this.setLoading()

            this.repositories.atendimentoIndividual.getInfraestruturas({
                usuario_id: this.data.model.cadastro.usuarioAuxiliar.id,
                unidade_id: this.data.model.cadastro.unidadeAuxiliarId
            })
                .then(({ data }) => {

                    this.infraestruturasAuxuliar = data

                    if (data.length === 1) {

                        this.data.model.cadastro.infraestruturaAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {

            this.setLoading()

            this.repositories.atendimentoIndividual.getEquipes({
                usuario_id: this.data.model.cadastro.usuario.id,
                infraestrutura_id: this.data.model.cadastro.infraestruturaId
            })
                .then(({ data }) => {

                    this.equipes = data
                    this.data.model.cadastro.equipes = data

                    if (data.length === 1){

                        this.data.model.cadastro.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipesAuxiliar() {

            this.setLoading()

            this.repositories.atendimentoIndividual.getEquipes({
                usuario_id: this.data.model.cadastro.usuarioAuxiliar.id,
                infraestrutura_id: this.data.model.cadastro.infraestruturaAuxiliarId
            })
                .then(({ data }) => {

                    this.equipesAuxiliar = data

                    if (data.length === 1){

                        this.data.model.cadastro.equipeAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {

            this.setLoading()

            this.repositories.atendimentoIndividual.getOcupacoes({
                usuario_id: this.data.model.cadastro.usuario.id,
                infraestrutura_id: this.data.model.cadastro.infraestruturaId
            })
                .then(({ data }) => {

                    this.ocupacoes = data

                    if (data.length === 1){

                        this.data.model.cadastro.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoesAuxiliar() {

            this.setLoading()

            this.repositories.atendimentoIndividual.getOcupacoesAuxiliar({
                usuario_id: this.data.model.cadastro.usuarioAuxiliar.id,
                infraestrutura_id: this.data.model.cadastro.infraestruturaAuxiliarId
            })
                .then(({ data }) => {

                    this.ocupacoesAuxiliar = data

                    if (data.length === 1){

                        this.data.model.cadastro.ocupacaoAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setCadastro(field) {

            if (field === 'usuario'){

                this.data.model.cadastro.unidadeId = null
                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
                this.data.model.cadastro.dataUsuarioResponsavel = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            } else if (field === 'infraestrutura'){

                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
                this.data.model.cadastro.dataUsuarioResponsavel = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            } else {

                this.data.model.cadastro.infraestruturaId = null
                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
                this.data.model.cadastro.dataUsuarioResponsavel = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            }
        },
        setAuxiliar(field) {

            if (field === 'usuario'){

                this.data.model.cadastro.unidadeAuxiliarId = null
                this.data.model.cadastro.equipeAuxiliarId = null
                this.data.model.cadastro.ocupacaoAuxiliarId = null
            } else if (field === 'infraestrutura') {

                this.data.model.cadastro.equipeAuxiliarId = null
                this.data.model.cadastro.ocupacaoAuxiliarId = null
            } else {

                this.data.model.cadastro.infraestruturaAuxiliarId = null
                this.data.model.cadastro.equipeAuxiliarId = null
                this.data.model.cadastro.ocupacaoAuxiliarId = null
            }
        },
        getMesesCompetencia() {
            const mesesCompetencia = [];

            for (let i = 0; i < 4; i++) {
                const mesCompetencia = moment().subtract(i, 'months').format('MM/YYYY');
                mesesCompetencia.push(mesCompetencia);
            }

            return mesesCompetencia.join(', ');
        },
    },
    data() {
        return {
            unidades: [],
            equipes: [],
            infraestruturas: [],
            ocupacoes: [],
            unidadesAuxiliar: [],
            infraestruturasAuxuliar: [],
            equipesAuxiliar: [],
            ocupacoesAuxiliar: [],
            enums: {
                permissao,
                tipoAtendimento
            }
        }
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
        agendamento: { type: Object, required: false },
        isAmbulatorio: { type: Boolean, default: false },
    },
    mounted () {
        this.$nextTick(function () {

            if (this.data.model.cadastro.usuario && this.data.model.cadastro.usuario.id && !this.isAmbulatorio) {

                this.getUnidades()

                if (this.data.model.cadastro.unidadeId) {

                    this.getInfraestruturas()
                    this.getEquipes()
                    this.getOcupacoes()
                }
            }

            if (this.data.model.cadastro.usuarioAuxiliar && this.data.model.cadastro.usuarioAuxiliar.id && !this.isAmbulatorio) {

                this.getUnidadesAuxiliar()

                if (this.data.model.cadastro.unidadeAuxiliarId) {

                    this.getInfraestruturasAuxiliar()
                    this.getEquipesAuxiliar()
                    this.getOcupacoesAuxiliar()
                }
            }

            if (this.isAmbulatorio) {

                this.equipes = this.agendamento.form.equipes
                this.data.model.atendimento.turnoId = this.agendamento.model.turnoId
                this.data.model.atendimento.localAtendimentoId = this.agendamento.model.atencaoBasicaLocalAtendimentoId

                if (this.agendamento.model.procedimentos) {

                    this.data.model.procedimentos = this.agendamento.model.procedimentos
                        .filter(procedimento => !procedimento.padrao && procedimento.usuario.id === this.agendamento.model.usuarioId)
                }

                if (this.agendamento.model.procedimento && this.agendamento.model.procedimento.id) {

                    const param = {
                        id: this.agendamento.model.procedimento.id,
                        nome: this.agendamento.model.procedimento.nome,
                        codigo: this.agendamento.model.procedimento.codigo,
                        padrao: true,
                        origem: 'ambulatorio'
                    }

                    this.data.model.procedimentos.push(param)
                }

                if (this.agendamento.model.agendamentoId) {

                    this.data.model.atendimento.tipoAtendimentoId = this.enums.tipoAtendimento.CONSULTA_AGENDADA
                } else {

                    this.data.model.atendimento.tipoAtendimentoId = this.enums.tipoAtendimento.CONSULTA_NO_DIA
                }

                if (this.data.model.cadastro.unidadeAuxiliarId) {

                    this.getUnidadesAuxiliar()
                    this.getInfraestruturasAuxiliar()
                    this.getEquipesAuxiliar()
                    this.getOcupacoesAuxiliar()
                }
            }
        })
    },
    watch: {
        'data.model.cadastro.usuario': function (usuario) {

            if (usuario && !this.isAmbulatorio) {

                this.getUnidades()
            }

            this.setCadastro('usuario')
        },
        'data.model.cadastro.usuarioAuxiliar': function (usuario) {

            if (usuario) {

                this.getUnidadesAuxiliar()
            }

            this.setAuxiliar('usuario')
        },
        'data.model.cadastro.unidadeId': function (unidadeId) {

            if (unidadeId && !this.isAmbulatorio) {

                this.getInfraestruturas()
            }

            this.setCadastro('unidade')
        },
        'data.model.cadastro.infraestruturaId': function (infraestruturaId) {

            if (infraestruturaId && !this.isAmbulatorio) {

                this.getEquipes()
                this.getOcupacoes()
            }

            this.setCadastro('infraestrutura')
        },
        'data.model.cadastro.unidadeAuxiliarId': function (unidadeId) {

            if (unidadeId) {

                this.getInfraestruturasAuxiliar()
            }

            this.setAuxiliar('unidade')
        },
        'data.model.cadastro.infraestruturaAuxiliarId': function (infraestruturaId) {

            if (infraestruturaId) {

                this.getEquipesAuxiliar()
                this.getOcupacoesAuxiliar()
            }

            this.setAuxiliar('infraestrutura')
        },
        'data.model.cadastro.dataUsuarioResponsavel': function (dataUsuarioResponsavel) {

            const mesesCompetencia = this.getMesesCompetencia()

            const limite = moment(this.data.form.dataAtual, 'DD/MM/YYYY').subtract(3, 'months').format('YYYY-MM')
            const dataCadastro = moment(dataUsuarioResponsavel).format('YYYY-MM')

            if (dataCadastro < limite) {

                this.showAlert(`Este atendimento está fora do prazo de faturamento, referente às competências
                    (<strong>${mesesCompetencia}</strong>). Embora seja possível finalizá-lo, não será possível
                    incluí-lo no processo de faturamento.`, 'Atenção')
            }
        },
    }
}
</script>